<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('op_69')"
    icon="res-sku"
    :res-name="detailData.name"
    :current-tab="params.windowData.currentTab"
    :tabs="detailTabs"
    :loaded="loaded"
    @tab-change="handleTabChange">
    <component :is="params.windowData.currentTab" :res-id="data.id + ''" :data="detailData" :getParams="getParams" :on-manager="onManager" res-type="billing_sku" />
  </base-side-page>
</template>

<script>
import ColumnsMixin from '../mixins/columns'
import Detail from './Detail'
import SkuHistoryRateList from './HistoryRateList'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'SKURateSidePage',
  components: {
    Detail,
    SkuHistoryRateList,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('compute.text_238'), key: 'detail' },
        { label: this.$t('op_92'), key: 'sku-history-rate-list' },
        { label: this.$t('compute.text_240'), key: 'event-drawer' },
      ],
    }
  },
  computed: {
    getParams () {
      if (this.params.windowData.currentTab === 'sku-history-rate-list') {
        return {
          rate_id: this.data.id,
        }
      }
      return null
    },
  },
}
</script>
